

import request from 'request';
import {serverSocketUrl,serverApiUrl} from '@/utils/config'
let baseServerUrl = serverApiUrl
// 添加用户
export function addUser(data) {
  return new Promise((resolve, reject) => {
    request.post(
      {
        url: baseServerUrl+'/users/addUser',
        json: true,
        body:data
      },
      (error, response, body) => {
        if (error) {
          reject(error);
        } else {
          resolve(body);
        }
      }
    );
  });
}

// 获取用户
export function getUser(userId) {
  return new Promise((resolve, reject) => {
    request.post(
      {
        url: baseServerUrl+`/users/${userId}`,
        json: true
      },
      (error, response, body) => {
        if (error) {
          reject(error);
        } else {
          resolve(body);
        }
      }
    );
  });
}

//获取用户列表

export function getAllUsers() {
  return new Promise((resolve, reject) => {
    request.get(
      {
        url: baseServerUrl+'/users/getAllUsers',
        json: true
      },
      (error, response, body) => {
        if (error) {
          reject(error);
        } else {
          resolve(body);
        }
      }
    );
  });
}

// 通过用户名和密码查询用户
export function login(username, password) {
  return new Promise((resolve, reject) => {
    request.post(
      {
        url: baseServerUrl+'/users/login',
        json: true,
        body: { username, password }
      },
      (error, response, body) => {
        if (error) {
          reject(error);
        } else {
          resolve(body);
        }
      }
    );
  });
}

// 更新用户
export function updateUser(userId, updatedUserData) {
  return new Promise((resolve, reject) => {
    request.post(
      {
        url: baseServerUrl+`/users/${userId}/update`,
        json: true,
        body: updatedUserData
      },
      (error, response, body) => {
        if (error) {
          reject(error);
        } else {
          resolve(body);
        }
      }
    );
  });
}

// 删除用户
export function deleteUser(userId) {
  return new Promise((resolve, reject) => {
    request.post(
      {
        url: baseServerUrl+`/users/${userId}/delete`,
        json: true
      },
      (error, response, body) => {
        if (error) {
          reject(error);
        } else {
          resolve(body);
        }
      }
    );
  });
}

//获取系统信息

export function getSysInfo() {
  return new Promise((resolve, reject) => {
    request.get(
      {
        url: baseServerUrl+`/sys/info`,
        json: true
      },
      (error, response, body) => {
        if (error) {
          reject(error);
        } else {
          resolve(body);
        }
      }
    );
  });
}
